import { Guid } from "@shared/utils/guid.helper";

export class Contact {
  contactId: string;
  individualId: string | null;
  organisationId?: string;
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  nickname: string;
  carbonCopy: string;
  blindCarbonCopy: string;
  isDeleted: boolean;
  fullName: string;

  constructor(contact: Partial<Contact> = {}) {
    this.contactId = contact.contactId ?? Guid.EmptyGuid;
    this.individualId = contact.individualId ?? null;
    this.organisationId = contact.organisationId ?? Guid.EmptyGuid;
    this.firstName = contact.firstName ?? '';
    this.lastName = contact.lastName ?? '';
    this.email = contact.email ?? '';
    this.phone = contact.phone ?? '';
    this.carbonCopy = contact.carbonCopy ?? '';
    this.blindCarbonCopy = contact.blindCarbonCopy ?? '';
    this.nickname = contact.nickname ?? '';
    this.isDeleted = contact.isDeleted ?? false;
    this.fullName = `${ this.firstName } ${ this.lastName }`;
  }
}
